import Vue from "vue";
import Vuex, { Payload } from "vuex";
import VuexPersistence from "vuex-persist";

import authModule from "./auth";
import attributeModule from "./attribute";
import catalogModule from "./catalog";
import itemModule from "./item";
import partnerModule from "./partner";
import roleModule from "./role";
import permissionModule from "./permission";
import tenantModule from "./tenant";
import faqModule from "./faq";
import servicerequestModule from "./servicerequest";
import orderModule from "./order";
import notificationModule from "./notification";
import advertiseModule from "./advertisement";
import inventoryModule from "./inventory";
import passwordResetModule from "./passwordReset";
import taxcodeModule from "./taxcode";
import couponModule from "./coupon";
import customerModule from "./customer";
import profileUpdateModule from "./profileUpdate";
import accessruleModule from "./accessrule";
import subscriptionPlanModule from "./subscriptionplan";
import deliveryModule from "./delivery";
import invoiceModule from "./invoice";
import subscriptionModule from "./subscriptions";
import walletstatementModule from "./walletStatement";
import serviceTicketModule from "./serviceticket";
import commissionModule from "./commission";
import paymentModule from "./partnerpayment";
import customerManagement from "./customerManagement";
import emailTemplateModule from "./emailtemplate";
import smsTemplateModule from "./smstemplate";
import whatsappTemplateModule from "./whatsapptemplate";
import concern from "./concern";
import Resources from "./currency";
import inappTemplateModule from "./inapptemplate";
import bulkNotificationModule from "./bulkNotification";
import approvalNotificationBulkModule from "./approvalNotificationBulk";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  modules: [
    "partner",
    "item",
    "subscription",
    "walletstatement",
    "serviceticket",
    "invoice",
    "advertisement"
  ],
  key: "nipige-state"
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    attribute: attributeModule,
    catalog: catalogModule,
    item: itemModule,
    partner: partnerModule,
    role: roleModule,
    permission: permissionModule,
    tenant: tenantModule,
    faq: faqModule,
    delivery: deliveryModule,
    servicerequest: servicerequestModule,
    auth: authModule,
    order: orderModule,
    notification: notificationModule,
    advertisement: advertiseModule,
    inventory: inventoryModule,
    passwordReset: passwordResetModule,
    taxcode: taxcodeModule,
    coupon: couponModule,
    customer: customerModule,
    profileUpdate: profileUpdateModule,
    accessrule: accessruleModule,
    subscriptionplan: subscriptionPlanModule,
    invoice: invoiceModule,
    subscription: subscriptionModule,
    walletstatement: walletstatementModule,
    serviceticket: serviceTicketModule,
    commission: commissionModule,
    payment: paymentModule,
    customerManagement:customerManagement,
    emailTemplate: emailTemplateModule,
    smsTemplate: smsTemplateModule,
    whatsappTemplate: whatsappTemplateModule,
    concern: concern,
    currency: Resources,
    inappTemplate: inappTemplateModule,
    bulkNotification: bulkNotificationModule,
    approvalNotificationBulk: approvalNotificationBulkModule,
  }
});
